import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import React from 'react';
import { useIntl } from 'react-intl';
import bulbTokens from '@amzn/meridian-tokens/base/icon/bulb';
import alertTokens from '@amzn/meridian-tokens/base/icon/alert-knockout';

import { MERIDIAN_COLORS } from '../../Util';
import Card, { CardHeader } from '@amzn/meridian/card';
import { css } from '@emotion/css';
import { RESOURCE_HUB_CONSTANTS } from './constants';
import useCustomTracking from '../../Util/useCustomTracking';
import useInspireOptions from '../../hooks/useInspireOptions';

export const FeedbackCardsRow: React.FC = () => {
  const intl = useIntl();

  return (
    <Row
      alignmentHorizontal='center'
      alignmentVertical='stretch'
      widths='fill'
      spacing='400'
      spacingInset='400 none'
    >
      <FeedbackCard
        title={intl.formatMessage({
          id: 'cs_perfportal_report_a_bug',
          defaultMessage: 'Report a Bug',
        })}
        description={intl.formatMessage({
          id: 'cs_perfportal_report_a_bug_description',
          defaultMessage: 'Create a SIM ticket reporting an issue',
        })}
        link={RESOURCE_HUB_CONSTANTS.BUG_REPORT_SIM_LINK}
        iconTokens={alertTokens}
        clickstreamTitle='Bug Report'
        clickstreamIdSuffix='bug-report'
      />
      <FeedbackCard
        title={intl.formatMessage({
          id: 'cs_perfportal_submit_feature_request',
          defaultMessage: 'Submit a Feature Request',
        })}
        description={intl.formatMessage({
          id: 'cs_perfportal_submit_feature_request_description',
          defaultMessage: 'Request a Feature',
        })}
        link={RESOURCE_HUB_CONSTANTS.NEW_FEATURE_SIM_LINK}
        iconTokens={bulbTokens}
        clickstreamTitle='Feature Request'
        clickstreamIdSuffix='feature-request'
      />
      {/* Placeholder div while we have two cards to make cards still be 1/3 width */}
      <div></div>
    </Row>
  );
};

interface FeedbackCardProps {
  title: string;
  description: string;
  link: string;
  iconTokens: Object;
  clickstreamIdSuffix: string;
  clickstreamTitle: string;
}
export const FeedbackCard: React.FC<FeedbackCardProps> = ({
  title,
  description,
  link,
  iconTokens,
  clickstreamIdSuffix,
  clickstreamTitle,
}) => {
  const { isTm, requesterUserID, requesterUsername } = useInspireOptions();

  const [ClickstreamTag, emitClickstreamClick] = useCustomTracking(
    `<resource-hub>-feedback-${clickstreamIdSuffix}`,
    '<resource-hub>-feedback-click',
    {
      'data-csa-c-type': 'button',
      'data-csa-c-tag1': '<resource-hub>',
      'data-csa-c-tag2': 'Feedback',
      'data-csa-c-tag3': clickstreamTitle,
      'data-csa-c-profile-id': requesterUserID,
      'data-csa-c-username': requesterUsername,
      'data-csa-c-is-tm': isTm,
    }
  );

  const handleFeedbackCardClick = (link: string) => {
    emitClickstreamClick();
    window.open(link, '_blank');
  };

  return (
    <div>
      <Card onClick={() => handleFeedbackCardClick(link)}>
        <CardHeader>
          <Heading
            level={2}
            type='h200'
            className={css({
              color: MERIDIAN_COLORS.MERIDIAN_COLOR_BLUE_500,
            })}
          >
            <Icon tokens={iconTokens} /> {title}
          </Heading>
        </CardHeader>
        <Text type='b300'>{description}</Text>
      </Card>
      <ClickstreamTag />
    </div>
  );
};
